"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextStep = void 0;
const getNextStep = (activeStep, hiddenSteps, direction = 'forward') => {
    const nextStep = direction === 'forward' ? activeStep + 1 : activeStep - 1;
    const hiddenIndex = Object.values(hiddenSteps).findIndex((stepNumber) => stepNumber === nextStep);
    if (hiddenIndex !== -1) {
        return (0, exports.getNextStep)(nextStep, hiddenSteps, direction);
    }
    return nextStep;
};
exports.getNextStep = getNextStep;
